import { EditProductItemSalePriceModal } from '@app/components/Modals';
import { PF } from '@app/pages/Warehouses/GoodsUnits/data';
import {
  useGoodsUnits,
  useGoodsUnitsEffects,
} from '@app/pages/Warehouses/GoodsUnits/hooks';
import { Filters, GoodsUnitsTable } from '@app/pages/Warehouses/GoodsUnits/ui';
import { FiltersAccordion } from '@app/shared/components';

import '@pages/Warehouses/GoodsUnits/styles/GoodsUnits.scss';

export const GoodsUnits = () => {
  const {
    statesOptions,
    productsOptions,
    warehousesOptions,
    columns,
    tableData,
    isPageLoading,
    isFetching,
    unsavedFilters,
    disabledFilters,
    onFilterChange,
    skipFilters,
    onSearch,
    pagination,
    onPaginate,
    onPageSizeChange,
    onSearchHandler,
    filtersListsHandler,
    isOpenEditSalePriceModal,
    editSalePriceProductUnit,
    onCloseEditSalePriceModal,
  } = useGoodsUnits();

  useGoodsUnitsEffects({ onSearchHandler, filtersListsHandler });

  return (
    <div className={`${PF}_container`}>
      <div className={`${PF}_filters-section`}>
        <FiltersAccordion>
          <Filters
            statesOptions={statesOptions}
            productsOptions={productsOptions}
            warehousesOptions={warehousesOptions}
            values={unsavedFilters}
            disabled={disabledFilters}
            onFilterChange={onFilterChange}
            skipFilters={skipFilters}
            onSearch={onSearch}
          />
        </FiltersAccordion>
      </div>

      <div className={`${PF}_table-section`}>
        <GoodsUnitsTable
          isPageLoading={isPageLoading}
          isFetching={isFetching}
          columns={columns}
          data={tableData}
          pagination={pagination}
          onPaginate={onPaginate}
          onPageSizeChange={onPageSizeChange}
        />
      </div>

      {!!editSalePriceProductUnit && (
        <EditProductItemSalePriceModal
          open={isOpenEditSalePriceModal}
          productItemId={editSalePriceProductUnit.Id}
          productName={editSalePriceProductUnit.Product}
          warehouseName={editSalePriceProductUnit.Warehouse}
          currentSalePrice={editSalePriceProductUnit.PriceOfSale}
          onClose={onCloseEditSalePriceModal}
          afterSave={onSearchHandler}
        />
      )}
    </div>
  );
};
